import React, { useEffect, useRef } from 'react';
import { Image, StyleSheet, TouchableOpacity, View, Text } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { Action } from '../shell/Actions/Action';
import Game from '../shell/Game';
import useFontSize from '../shell/hooks/useFontSize';
import UI, { UIINT } from '../shell/UI';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setAdvance } from '../store/slices/AdvanceSlice';
import { selectUi, setUI } from '../store/slices/gameObjectSlice';
import { TUIButton } from './TUIButton';

const TUI = () => {

    const uiSlice = useAppSelector(selectUi);

    const dispatch = useAppDispatch();
    const size = useFontSize(12);


    const styles = StyleSheet.create({

        container: {
            position: "absolute",
            bottom: "5%",
            left: size,
            flexDirection: "row"
            // width: "30%",
        },
        uiWrapper: {
            // position: "absolute",
            height: size,
            width: size,
            display: "flex",
            alignItems: "center",
        },
        uiStyle: {

            // position: "absolute",
            resizeMode: 'cover',
            height: size,
            width: size,

        },
        tooltip: {
            color: "white",
            position: "absolute",
            top: -30,
            fontSize: useFontSize(1.5),

        }
    });



    const handleOnClick = async (value: UIINT) => {

        dispatch(setAdvance({ canAdvance: true, promise: value.key }));
        dispatch(setUI({ displayUI: false, key: uiSlice.key, btns: [], value: value.key }));

    };

    return (
        <>
            {uiSlice.displayUI ?
                <View style={styles.container}>
                    {uiSlice.btns.map((ui) => {
                        if (ui.hide || ui.show === false) { return (<React.Fragment key={ui.key}></React.Fragment>); }
                        return (
                            <React.Fragment key={ui.key}>
                                <TUIButton ui={ui} size={size} onButtonPressed={(ui) => handleOnClick(ui)}></TUIButton>
                            </React.Fragment>
                        );
                    }
                    )}
                </View>
                : <></>}
        </>
    );
};

export default TUI;
